import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=35419e1e&scoped=true"
import script from "./MessageEditor.vue?vue&type=script&lang=js"
export * from "./MessageEditor.vue?vue&type=script&lang=js"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=35419e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35419e1e",
  null
  
)

export default component.exports